import ls from "@livesession/sdk";

export class LiveSession {
  element: HTMLElement;
  trackId: string = process.env["LIVE_SESSION_TRACK_ID"] || '';
  observer: IntersectionObserver;
  intersectionObserverOptions = {
    rootMargin: '0px',
    threshold: 0,
  };
  rootHostname = '.wyborcza.pl';

  constructor(element: HTMLElement) {
    this.element = element;
  }

  init(): void {
    if (!this.element || !this.trackId) return;

    this.observer = new IntersectionObserver(
      (entries: IntersectionObserverEntry[]) => this.onIntersect(entries),
      this.intersectionObserverOptions
    );

    this.observer.observe(this.element);
  }

  onIntersect(entries: IntersectionObserverEntry[]): void {
    entries.forEach((entry) => {
      this.liveSessionInit(entry);
    });
  }

  liveSessionInit(entry: IntersectionObserverEntry): void {
    if (!entry.isIntersecting)
      return;

    ls.init(this.trackId, { keystrokes: false, rootHostname: this.rootHostname });
    ls.newPageView();

    this.unobserve();
  }

  unobserve(): void {
    this.observer.unobserve(this.element);
  }
}
